'use client'

import { useTopicContext } from './TopicContext'

const MAX_FAVICONS = 5

export default function SubtopicArticles({ articles, sectionId, sectionName }) {
  const { filterBySection, openMobileModal } = useTopicContext()

  if (!articles || articles.length === 0) return null

  // Get unique outlets (first article per outlet)
  const seenOutlets = new Set()
  const uniqueOutletArticles = articles.filter(article => {
    const outletSlug = article.outlet?.slug
    if (!outletSlug || seenOutlets.has(outletSlug)) return false
    seenOutlets.add(outletSlug)
    return true
  })

  const visibleArticles = uniqueOutletArticles.slice(0, MAX_FAVICONS)

  // Desktop: filter sidebar to this section
  const handleDesktopViewArticles = () => {
    filterBySection(sectionId, sectionName, articles)
  }

  // Mobile: open modal
  const handleMobileViewArticles = () => {
    openMobileModal(articles, sectionName)
  }

  return (
    <div className="mt-3 flex items-center gap-3">
      {/* Overlapping favicons */}
      <div className="flex -space-x-1.5">
        {visibleArticles.map((article) => (
          <div
            key={article.id}
            className="relative w-6 h-6 rounded-full border-2 border-background bg-card overflow-hidden"
            title={article.outlet?.name}
          >
            {article.outlet?.image ? (
              <img
                src={article.outlet.image}
                alt={article.outlet.name}
                className="w-full h-full object-contain"
              />
            ) : (
              <div className="w-full h-full bg-muted flex items-center justify-center text-[10px] text-muted-foreground">
                {article.outlet?.name?.charAt(0)}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Desktop: View all articles link */}
      <button
        onClick={handleDesktopViewArticles}
        className="hidden lg:block text-xs text-muted-foreground hover:text-foreground transition-colors"
      >
        View all {articles.length} articles
      </button>

      {/* Mobile: View all articles button */}
      <button
        onClick={handleMobileViewArticles}
        className="lg:hidden text-xs font-medium text-accent hover:text-accent/80 transition-colors"
      >
        View all {articles.length} articles
      </button>
    </div>
  )
}
